import { Injectable } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { AuctionEntity, HomePageEnum } from 'libs/gb-front/auction/data-access/src'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import { EventTicketsConstants } from 'libs/gb-front/event-tickets/feature/src/lib/event-tickets-constants'
import { HubConstants } from 'libs/gb-front/hub/feature/src/lib/gb-front-hub-feature-constants'
import { InfoConstants } from 'libs/gb-front/infobooth/feature/src/lib/gb-info-constants'
import { ItemConstants } from 'libs/gb-front/item/feature/src/lib/item-constants'
import { Observable, map } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbAuctionHomeUrlService {
  constructor(private auctionFacade: AuctionFacade, private router: Router) {}

  public static getAuctionHomepage(auction: AuctionEntity) {
    switch (auction.homepage) {
      case HomePageEnum.InfoBooth:
        return [auction.url_name, InfoConstants.INFO, auction.homepage_infobooth]
      case HomePageEnum.Hub:
        return [auction.url_name, HubConstants.HUBS, auction.homepage_hub]
      case HomePageEnum.Auction:
        return [auction.url_name, ItemConstants.ITEMS]
      case HomePageEnum.EventTicketing:
        return [auction.url_name, EventTicketsConstants.EVENT_TICKETS]
      default:
        return [auction.url_name, ItemConstants.ITEMS]
    }
  }

  public homeUrlFragments$: Observable<string[]> = this.auctionFacade.auction$.pipe(
    map((auction) => GbAuctionHomeUrlService.getAuctionHomepage(auction)),
  )

  public homeUrlTree$: Observable<UrlTree> = this.homeUrlFragments$.pipe(
    map((fragments) => this.router.createUrlTree(fragments)),
  )
}
